import { render, staticRenderFns } from "./office-search.vue?vue&type=template&id=9923758a&"
import script from "./office-search.vue?vue&type=script&lang=js&"
export * from "./office-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9923758a', component.options)
    } else {
      api.reload('9923758a', component.options)
    }
    module.hot.accept("./office-search.vue?vue&type=template&id=9923758a&", function () {
      api.rerender('9923758a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/custom-apps/containers/office-search.vue"
export default component.exports